import React, { useEffect, useRef, useState } from "react";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../loading";
import { GetRetailerDetails } from "../../API  Functions/ProfileFunctions";
import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Breadcrumb, Drawer } from "antd";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Navbar from "../Navbar/Navbar";
import { DoubleRightOutlined } from "@ant-design/icons";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import Calandericon from "../../assets/calendar-03.svg";
import subscriptionCheck from "../../assets/subcriptionCheck.svg";
import { checkPermission } from "../../Utils/permissionHelper";

const renderHistoryData = (data, t) => {
  let status = "";

  if (data?.status === "PAID") {
    status = "Paid";
  } else if (data?.status === "waiting_pay_confirm" || data?.status === "NEW") {
    status = "Pending";
  } else if (data?.status === "CANCELED") {
    status = "Cancelled";
  } else if (data?.status === "FAILED") {
    status = "Failed";
  } else if (data?.status === "REFUNDED") {
    status = "Refunded";
  } else if (data?.status === "PARTIAL_REFUNDED") {
    status = "Partially Refunded";
  } else if (data?.status === "EXPIRED") {
    status = "Expired";
  }

  return (
    <div className="bg-[#F6F6F6] p-4 mb-4 rounded-lg">
      <div className="text-lg justify-center text-center font-semibold">
        {t(data?.plan) || "-"}
      </div>

      <div className="grid grid-cols-1 gap-2 mt-2">
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Shop Name")}</p>
          <p className="text-sm">{data?.customer || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Plan")}</p>
          <p className="text-sm">{t(data?.plan) || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Duration")}</p>
          <p className="text-sm">{t(data?.duration) || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Start date")}</p>
          <p className="text-sm">{data?.start_date || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Due date")}</p>
          <p className="text-sm">{data?.end_date || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Invoice Date")}</p>
          <p className="text-sm">{data?.invoice_date || "-"}</p>
        </div>
        {data?.additional_no_of_user != 0 &&
          data?.additional_no_of_device != 0 && (
            <>
              <div className="flex justify-between">
                <p className="font-normal text-sm">{t("No. of Users")}</p>
                <p className="text-sm">{data?.additional_no_of_user || "-"}</p>
              </div>
              <div className="flex justify-between">
                <p className="font-normal text-sm">{t("No. of Machines")}</p>
                <p className="text-sm">
                  {data?.additional_no_of_device || "-"}
                </p>
              </div>
            </>
          )}

        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Amount")}</p>
          <p className="text-sm">{data?.amount ? `EGP ${data.amount}` : "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Invoice Number")}</p>
          <p className="text-sm">{data?.invoice_num || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Payment Reference Number")}</p>
          <p className="text-sm">{data?.pay_ref_num || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Payment Mode")}</p>
          <p className="text-sm">{data?.payment_mode || "-"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-normal text-sm">{t("Status")}</p>
          <p className="text-sm">{t(status) || "-"}</p>
        </div>
      </div>
    </div>
  );
};

// const planRanks = {
//   Standard: 1,
//   "Standard Plus": 2,
//   Business: 3,
//   "Business Pro": 4,
// };

const Subscription = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(2);
  const [billing, setBilling] = useState("Yearly");
  const [loading, setLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  const [subscriptioPacks, setSubscriptioPacks] = useState([]);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [retailerDetails, setretailerData] = useState({});
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const activePlan = subscriptionDetails?.plan_id
    ? subscriptioPacks?.find((p) => p.id === subscriptionDetails?.plan_id)
    : null;

  const planRanks = {};
  subscriptioPacks
    ?.filter((p) => p.billing_type === "Monthly") // only compare monthly costs
    .sort((a, b) => a.cost - b.cost) // sort lowest to highest
    .forEach((plan, index) => {
      planRanks[plan.plan_name] = index + 1; // assign rank
    });

  const billingTypes = [
    ...new Set(subscriptioPacks.map((plan) => plan.billing_type)),
  ];

  const billingRank = {
    Monthly: 1,
    Quarterly: 2,
    "Half-Yearly": 3,
    Yearly: 4,
  };

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -400 : 400, // adjust scroll distance
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    fetchdetails();
    GetSubscriptionPlans();
    GetMySubscription();
  }, []);

  useEffect(() => {
    if (showHistory) {
      GetSubscriptionHistory();
    }
  }, [showHistory]);

  const GetSubscriptionHistory = async () => {
    try {
      setHistoryLoading(true);

      // setLoading(true);
      const response = await axiosInstance.post(URLS.GET_SUBSCRIPTION_HISTORY, {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        user_id: user_id,
      });
      // console.log("DATA===>", response?.data);
      let data = response?.data;
      if (!data?.error && data.result[0]?.status_code == 200) {
        setSubscriptionHistory(data.result[0].response);
      } else {
        setSubscriptionHistory([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setLoading(false);
    } finally {
      setHistoryLoading(false);
      // setLoading(false);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };

  const GetMySubscription = async () => {
    try {
      // setLoading(true);
      const response = await axiosInstance.post(
        URLS.GET_RETAILER_SUBSCRIPTION,
        {
          lang: i18n.language === "ar" ? "ar_001" : "en_US",
          user_id: user_id,
        },
      );
      // console.log("DATA===>", response?.data);
      let data = response?.data;
      if (!data?.error && data.result[0]?.status_code == 200) {
        setSubscriptionDetails(data.result[0].response[0]);
        setBilling(data.result[0].response[0]?.duration || "Yearly");
      } else {
        setSubscriptionDetails();
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setLoading(false);
    } finally {
      // setLoading(false);
    }
  };

  const GetSubscriptionPlans = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_SUBSCRIPTION_PLANS, {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });
      // console.log("DATA===>", response?.data);

      if (response?.data?.result?.status === 200) {
        setSubscriptioPacks(response?.data?.result?.data);
      } else {
        setSubscriptioPacks([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const parseDescription = (desc) =>
    desc
      .split("\n")
      .filter((line) => line.trim() !== "")
      .map((line) => line.replace("✅", "").trim());

  const groupPlans = (plans) => {
    return plans.reduce((acc, plan) => {
      const billingType = plan?.billing_type;

      if (!acc[plan.plan_name]) {
        acc[plan.plan_name] = {};
      }

      // Dynamically assign billing type
      acc[plan.plan_name][billingType] = plan;

      return acc;
    }, {});
  };

  const groupedPlans =
    subscriptioPacks?.length > 0 ? groupPlans(subscriptioPacks) : [];

  const endDate = new Date(subscriptionDetails?.plan_end_date);
  const today = new Date();

  // Calculate remaining days
  const diffTime = endDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const trialDateStr = subscriptionDetails?.end_date_trial
    ? subscriptionDetails?.end_date_trial
    : null;

  // Parsing yyyy-dd-mm → [year, day, month]
  const [year, month, day] = trialDateStr ? trialDateStr.split("-") : "";
  const trialEndDate = new Date(year, month - 1, day);

  const divRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (divRef.current) {
      // getBoundingClientRect gives you pixel width
      setWidth(divRef.current.getBoundingClientRect().width);
    }

    // Optional: recalc on window resize
    const handleResize = () => {
      if (divRef.current) {
        setWidth(divRef.current.getBoundingClientRect().width);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const counts = subscriptioPacks.reduce((acc, item) => {
    acc[item.billing_type] = (acc[item.billing_type] || 0) + 1;
    return acc;
  }, {});

  // console.log("billingRank[activePlan?.billing_type]==>",billingRank[activePlan?.billing_type]);

  return (
    <div className="w-full flex flex-col md:h-full  overflow-y-auto  bg-gradient-to-bl from-[#F7EEC4] to-gray-50">
      <Navbar
        heading="Subscription"
        expireDate={
          retailerDetails?.status == "approved" &&
          subscriptionDetails?.status == "active" &&
          subscriptionDetails?.is_trial &&
          today <= trialEndDate
            ? subscriptionDetails?.end_date_trial
            : null
        }
      />
      <div
        ref={divRef}
        className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden  mt-2 w-full"
      >
        {/* Toggle */}
        {loading ? (
          <div className="flex flex-col md:flex-row justify-center gap-6 mt-20 w-full mx-4 md:mx-0">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-white rounded-2xl shadow-md p-6 w-11/12 md:w-4/12 h-[450px] flex flex-col"
              >
                <Stack spacing={2} className="h-full pt-5">
                  {/* Title */}
                  <div className=" flex justify-center ">
                    <Skeleton variant="text" width={160} height={32} />
                  </div>

                  <div className="flex items-center justify-between my-6">
                    {/* Price */}
                    <div>
                      <Skeleton variant="text" width={100} height={40} />
                      <Skeleton variant="text" width={140} height={20} />
                    </div>
                    {/* Security Deposit */}
                    <div className="text-right">
                      <Skeleton variant="text" width={100} height={40} />
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                  </div>

                  <div className="border-t my-4" />

                  {/* Plan Benefits */}
                  <Stack spacing={1}>
                    <Skeleton variant="text" width={240} height={20} />
                    <Skeleton variant="text" width={220} height={20} />
                    <Skeleton variant="text" width={200} height={20} />
                    <Skeleton variant="text" width={180} height={20} />
                    <Skeleton variant="text" width={180} height={20} />
                    <Skeleton variant="text" width={180} height={20} />
                  </Stack>

                  <div className=" flex justify-center mt-10">
                    <Skeleton variant="rectangular" width={"90%"} height={40} />
                  </div>
                </Stack>
              </div>
            ))}
          </div>
        ) : (
          <>
            {retailerDetails?.status == "approved" ? (
              <>
                {subscriptionDetails?.status == "active" &&
                  subscriptionDetails?.duration &&
                  subscriptionDetails?.plan_start_date &&
                  !subscriptionDetails?.is_trial &&
                  !activePlan?.id && (
                    <div className="px-6 py-4  text-base font-semibold text-[#B08D15] border border-[#FFE4B2] rounded-xl mx-4 bg-[#FFF7ED]">
                      <div className="flex justify-between ">
                        <div>
                          <span className="text-[#232323]">
                            {t("Current Plan: ")}
                          </span>{" "}
                          <span className="text-[#232323] italic">
                            {`${t("Regular")} (${t(
                              subscriptionDetails?.duration,
                            )})`}
                          </span>
                        </div>
                        <div className="text-sm">
                          <span className="text-[#232323]">
                            {t("Plan Amount:")}
                          </span>{" "}
                          <span className="text-green-700">
                            EGP {subscriptionDetails?.amount?.toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <div className="flex justify-between mt-1 text-sm ">
                        <p className="text-[#646464] font-medium">
                          {t("You’re currently on our Regular plan")}
                        </p>
                        <div className="font-semibold flex items-center">
                          <img
                            className="w-7 h-7 me-1 mb-1 object-cover rounded-full"
                            src={Calandericon}
                            alt=""
                          />
                          <div>
                            <span className="text-[#232323]">
                              {t("Plan Ends On:")}
                            </span>{" "}
                            <span className="text-[#EB5A26]">
                              {subscriptionDetails?.plan_end_date}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                <div className="flex flex-col-reverse md:flex-row justify-between w-full px-4 items-center mt-2 mb-2 md:mt-4 md:mb-5">
                  <div className="w-24"></div>
                  <div className="flex bg-gray-200 rounded-full p-1">
                    {/* <div className="flex bg-gray-200 rounded-full p-1"> */}
                    {[...billingTypes].reverse().map((type) => (
                      <button
                        key={type}
                        onClick={() => setBilling(type)}
                        className={`px-6 py-2 rounded-full font-medium transition ${
                          billing === type
                            ? "bg-gray-800 text-white"
                            : "text-gray-600"
                        }`}
                      >
                        {t(type)}
                      </button>
                    ))}
                    {/* </div> */}
                  </div>
                  <button
                    className="mb-4 md:mb-0 w-36 h-10 bg-primaryBlue text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2"
                    onClick={() => setShowHistory(true)}
                  >
                    <span>{t("Payment History")}</span>
                  </button>
                </div>
                {/* Plans */}

                <div className="relative w-full">
                  <div
                    ref={scrollRef}
                    className=" w-full md:overflow-x-auto py-6 md:hide-scrollbar px-3"
                  >
<div className="flex flex-col md:flex-row gap-4 pb-2 items-stretch md:justify-center">
                        {subscriptioPacks
                        ?.filter((plan) => plan.billing_type === billing)
                        ?.map((plan, index) => {
                          const isSelected = selectedPlan === plan.id;
                          const isActivePlan =
                            subscriptionDetails?.status == "active" &&
                            subscriptionDetails?.plan_id
                              ? subscriptionDetails?.plan_id === plan?.id
                              : false; // check active
                          const benefits = plan.description
                            ? parseDescription(plan.description)
                            : [];

                          return (
                            <div
                              key={plan.id}
                              style={{
                                width:
                                  window.innerWidth < 768
                                    ? "100%"
                                    : width
                                      ? `${(width - 100) / (counts[billing] || 3.4)}px`
                                      : "100%",
                              }}
                              className={`relative rounded-2xl flex items-end cursor-pointer bg-primaryBlue transition
                              border-2 border-white hover:border-2 hover:border-primaryBlue hover:shadow-lg ${
                                plan.is_most_popular ? "bg-primaryBlue" : "bg-white"
                              }`}
                            >
                              <div
                                className={`bg-white w-full p-6 rounded-t-2xl rounded-b-xl flex flex-col hover:bg-[#ECF3FF] ${
                                  plan.is_most_popular ? "h-[98%]" : "h-full"
                                }`}
                              >
                                {/* Tag */}
                                {plan.is_most_popular && (
                                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-2 text-xs font-semibold rounded-full bg-gradient-to-r from-[#F8C42B] to-[#F6A669] text-white">
                                    {t("MOST POPULAR")}
                                  </div>
                                )}

                                {/* Active badge */}
                                {isActivePlan && (
                                  <div className="absolute top-4 right-4 px-3 py-1 text-xs font-semibold rounded-full bg-[#7EC242] text-white shadow">
                                    {t("Active")}
                                  </div>
                                )}

                                {/* Title */}
                                <h2 className="text-lg text-center font-bold mb-2 mt-6 uppercase">
                                  {t(plan.plan_name)}
                                </h2>

                                {/* Price */}
                                <div
                                  className={`flex items-end ${
                                    plan.per_device_security_deposit > 0
                                      ? "justify-between"
                                      : "justify-center"
                                  }`}
                                >
                                  <div
                                    className={`flex flex-col ${
                                      plan.per_device_security_deposit > 0
                                        ? ""
                                        : "items-center"
                                    }`}
                                  >
                                    <div className="text-gray-500 text-sm">
                                      {t("Starts at")}
                                    </div>
                                     {/* Actual Price (Strikethrough) */}
                                    {plan.actual_price && plan.actual_price >= 1 ? (
                                      <div className="flex my-1">
                                        <div className="text-gray-400 text-base line-through">
                                          {plan.currency} {plan.actual_price}
                                        </div>
                                        <div className="px-2 py-1 text-xs mx-1 font-semibold rounded-full bg-gradient-to-r from-[#F8C42B] to-[#F6A669] text-white flex items-center">
                                          {plan.offer_percentage}%Off
                                        </div>
                                      </div>
                                    ): <></>}

                                    {/* Discounted Price */}
                                    <div className="text-primaryBlue text-xl font-bold">
                                      {plan.currency} {plan.cost}
                                    </div>

                                    <div className="text-gray-500 text-sm mb-2">
                                      {plan.no_of_user
                                        ? `${t("Including")} ${plan.no_of_user} ${t("Users")}`
                                        : plan.billing_type}
                                    </div>
                                  </div>

                                  {/* Extra monthly fee */}
                                  {plan.per_device_security_deposit > 0 && (
                                    <div className="gap-2 mb-2">
                                      <p className="text-primaryBlue text-xl font-bold">
                                        {plan.currency}{" "}
                                        {plan.per_device_security_deposit}
                                      </p>
                                      <p className="text-gray-500 text-sm">
                                        {t("Security Deposit")}
                                      </p>
                                    </div>
                                  )}
                                </div>

                                {/* Divider */}
                                <div className="border-t border-gray-300 my-4"></div>

                                {/* Benefits */}
                                <h3 className="text-sm font-semibold mb-3">
                                  {t("Plan Benefits")}
                                </h3>
                                <ul className="space-y-2 mb-3 flex-1">
                                  {benefits.map((benefit, idx) => (
                                    <li
                                      key={idx}
                                      className="flex items-center gap-2 text-gray-700 text-sm"
                                    >
                                      <img
                                        className="w-5 h-5 object-contain"
                                        src={subscriptionCheck}
                                        alt="Minus icon"
                                      />
                                      <span>{benefit}</span>{" "}
                                    </li>
                                  ))}
                                </ul>

                                {/* Footer (pushed to bottom by flex-1 above) */}
                                {isActivePlan ? (
                                  <div className="text-sm text-gray-600  mt-auto">
                                    <p className="mb-1">
                                      {t("Last Date of Purchase")}:{" "}
                                      <span className="font-semibold">
                                        {subscriptionDetails?.plan_start_date}
                                      </span>
                                    </p>
                                    <p className="mb-1">
                                      {t("Next Renewal Date")}:{" "}
                                      <span className="font-semibold">
                                        {subscriptionDetails?.next_renewal_date}
                                      </span>
                                    </p>
                                    <p className="mb-1">
                                      {t("Payment Method")}:{" "}
                                      <span className="font-semibold">
                                        {subscriptionDetails?.payment_mode}
                                      </span>
                                    </p>
                                    {subscriptionDetails?.is_advance_payment && (
                                      <p className="text-green-700 font-medium my-1">
                                        {t(
                                          "You’ve already paid for your upcoming subscription. It will automatically begin once your current plan ends.",
                                        )}
                                      </p>
                                    )}

                                    {diffDays <= 2 ? (
                                      <button
                                        disabled={
                                          subscriptionDetails?.is_advance_payment
                                        }
                                        // onClick={() =>
                                        //   navigate(
                                        //     "/settings/renewsubscription",
                                        //     {
                                        //       state: {
                                        //         plans:
                                        //           groupedPlans[plan.plan_name],
                                        //         subscriptionDetails,
                                        //         page: billing,
                                        //         isrenew: true,
                                        //       },
                                        //     }
                                        //   )
                                        // }

                                        onClick={() => {
                                          if (
                                            checkPermission(
                                              "/settings/subscription",
                                              isGinne,
                                            )
                                          ) {
                                            navigate(
                                              "/settings/renewsubscription",
                                              {
                                                state: {
                                                  plans:
                                                    groupedPlans[
                                                      plan.plan_name
                                                    ],
                                                  subscriptionDetails,
                                                  page: billing,
                                                  isrenew: true,
                                                },
                                              },
                                            );
                                          }
                                        }}
                                        className="w-full mt-2 py-2 rounded-xl font-semibold bg-yellow-400 text-white transition disabled:opacity-50"
                                      >
                                        {t("Renew Plan")}
                                      </button>
                                    ) : (
                                      <button
                                        // onClick={() =>
                                        //   navigate(
                                        //     "/settings/renewsubscription",
                                        //     {
                                        //       state: {
                                        //         plans:
                                        //           groupedPlans[plan.plan_name],
                                        //         subscriptionDetails,
                                        //         page: billing,
                                        //         isrenew: true,
                                        //       },
                                        //     }
                                        //   )
                                        // }

                                        onClick={() => {
                                          if (
                                            checkPermission(
                                              "/settings/subscription",
                                              isGinne,
                                            )
                                          ) {
                                            navigate(
                                              "/settings/renewsubscription",
                                              {
                                                state: {
                                                  plans:
                                                    groupedPlans[
                                                      plan.plan_name
                                                    ],
                                                  subscriptionDetails,
                                                  page: billing,
                                                  isrenew: true,
                                                },
                                              },
                                            );
                                          }
                                        }}
                                        className="w-full mt-5 py-2 rounded-xl font-semibold bg-yellow-400 text-white transition"
                                      >
                                        {t("Add Additional Features")}
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <>
                                    {subscriptionDetails?.status == "active" &&
                                    subscriptionDetails?.plan_id ? (
                                      <button
                                        // onClick={() =>
                                        //   navigate(
                                        //     "/settings/renewsubscription",
                                        //     {
                                        //       state: {
                                        //         plans:
                                        //           groupedPlans[plan.plan_name],
                                        //         subscriptionDetails,
                                        //         page: billing,
                                        //         isrenew: false,
                                        //       },
                                        //     }
                                        //   )
                                        // }
                                        onClick={() => {
                                          if (
                                            checkPermission(
                                              "/settings/subscription",
                                              isGinne,
                                            )
                                          ) {
                                            navigate(
                                              "/settings/renewsubscription",
                                              {
                                                state: {
                                                  plans:
                                                    groupedPlans[
                                                      plan.plan_name
                                                    ],
                                                  subscriptionDetails,
                                                  page: billing,
                                                  isrenew: false,
                                                },
                                              },
                                            );
                                          }
                                        }}
                                        disabled={
                                          (!(isActivePlan && diffDays <= 2) &&
                                            subscriptionDetails?.status ===
                                              "active" &&
                                            planRanks[activePlan?.plan_name] >
                                              planRanks[plan?.plan_name]) ||
                                          subscriptionDetails?.is_advance_payment ||
                                          billingRank[
                                            activePlan?.billing_type
                                          ] > billingRank[plan?.billing_type]
                                        }
                                        className={`w-full mt-auto py-2 rounded-xl font-semibold transition bg-primaryBlue text-white disabled:opacity-50`}
                                      >
                                        {t("Get")}
                                      </button>
                                    ) : (
                                      <button
                                        // onClick={() =>
                                        //   navigate(
                                        //     "/settings/renewsubscription",
                                        //     {
                                        //       state: {
                                        //         plans:
                                        //           groupedPlans[plan.plan_name],
                                        //         subscriptionDetails,
                                        //         page: billing,
                                        //         isrenew: true,
                                        //       },
                                        //     }
                                        //   )
                                        // }
                                        onClick={() => {
                                          if (
                                            checkPermission(
                                              "/settings/subscription",
                                              isGinne,
                                            )
                                          ) {
                                            navigate(
                                              "/settings/renewsubscription",
                                              {
                                                state: {
                                                  plans:
                                                    groupedPlans[
                                                      plan.plan_name
                                                    ],
                                                  subscriptionDetails,
                                                  page: billing,
                                                  isrenew: true,
                                                },
                                              },
                                            );
                                          }
                                        }}
                                        disabled={
                                          (!(isActivePlan && diffDays <= 2) &&
                                            subscriptionDetails?.status ===
                                              "active" &&
                                            planRanks[activePlan?.plan_name] >
                                              planRanks[plan?.plan_name]) ||
                                          subscriptionDetails?.is_advance_payment ||
                                          (subscriptionDetails?.status ===
                                            "active" &&
                                            billingRank[
                                              activePlan?.billing_type
                                            ] > billingRank[plan?.billing_type])
                                        }
                                        className={`w-full mt-auto py-2 rounded-xl font-semibold transition bg-primaryBlue text-white disabled:opacity-50 `}
                                      >
                                        {t("Get")}
                                      </button>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  {/* <button
                    onClick={() =>
                      i18n.language === "ar" ? scroll("left") : scroll("right")
                    }
                    className={`absolute top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white border rounded-full shadow-md p-2 z-50 group-hover:opacity-100 transition
                           ${i18n.language === "ar" ? "left-10" : "right-10"}`}
                  >
                    {i18n.language === "ar" ? (
                      <LeftOutlined />
                    ) : (
                      <RightOutlined />
                    )}
                  </button> */}
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-center w-full mt-16 text-base text-body text-center p-3 font-normal ">
                  {retailerDetails?.status &&
                  retailerDetails?.status != "approved"
                    ? t(
                        "You cannot purchase a subscription until your store is approved by myGINNE.",
                      )
                    : ""}
                </div>
              </>
            )}
          </>
        )}

        <Drawer
          // title={t("Session History")}
          title={t("Subscription History")}
          placement="right"
          width={500}
          onClose={() => setShowHistory(false)}
          visible={showHistory}
        >
          {/* Display the session history data */}
          {historyLoading ? (
            <ShimmerLoader />
          ) : (
            <div>
              {subscriptionHistory?.length > 0 ? (
                subscriptionHistory?.map((data) => renderHistoryData(data, t))
              ) : (
                <div className="flex justify-center items-center">
                  <p>{t("No history available")}</p>
                </div>
              )}
            </div>
          )}
        </Drawer>
      </div>
    </div>
  );
};

export default Subscription;
